import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
// Self-hosted, as in the app: the page makes no third-party requests.
import "@fontsource/ibm-plex-sans/400.css";
import "@fontsource/ibm-plex-sans/500.css";
import "@fontsource/ibm-plex-sans/600.css";
import "@fontsource/ibm-plex-mono/400.css";
import "@fontsource/ibm-plex-mono/500.css";
// Newsreader italic is the voice of the product's own sentences ("If Acme leaves, …"), as in the app.
import "@fontsource-variable/newsreader/opsz-italic.css";
import "./index.css";
import { App } from "./App";

createRoot(document.getElementById("root")!).render(
	<StrictMode>
		<App />
	</StrictMode>,
);
